import { render, staticRenderFns } from "./TtsButton.vue?vue&type=template&id=419666dd&scoped=true&lang=pug&"
import script from "./TtsButton.vue?vue&type=script&lang=js&"
export * from "./TtsButton.vue?vue&type=script&lang=js&"
import style0 from "./TtsButton.vue?vue&type=style&index=0&id=419666dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419666dd",
  null
  
)

export default component.exports